import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@material-ui/core';

export default function CategoriesFilterDialog({
  open,
  onCancel,
  onApply,
  allCategories,
  selectedCategories,
}) {
  const [localSelection, setLocalSelection] = useState([]);

  // Sync local selection from parent whenever dialog opens or selection changes
  useEffect(() => {
    if (open) {
      setLocalSelection(selectedCategories || []);
    }
  }, [open, selectedCategories]);

  const handleToggle = (cat) => {
    setLocalSelection((prev) => {
      const exists = prev.includes(cat);
      return exists ? prev.filter((c) => c !== cat) : [...prev, cat];
    });
  };

  const handleReset = () => {
    setLocalSelection([]);
  };

  const handleApply = () => {
    onApply(localSelection);
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '80vh',
          maxHeight: '80vh',
        },
      }}
    >
      <DialogTitle style={{ color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.9)' }}>
        Select categories
      </DialogTitle>
      <DialogContent
        dividers
        style={{
          flex: 1,
          overflowY: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          paddingTop: 4,
          paddingBottom: 60, // leave room for sticky footer
        }}
      >
        <List dense>
          {allCategories.map((cat) => {
            const checked = localSelection.includes(cat);
            const labelId = `category-${cat}`;
            return (
              <ListItem
                key={cat}
                button
                onClick={() => handleToggle(cat)}
                style={{ paddingTop: 0, paddingBottom: 0, minHeight: 22 }}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checked}
                    tabIndex={-1}
                    disableRipple
                    style={{ color: '#fff' }}
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText
                  id={labelId}
                  primary={cat}
                  primaryTypographyProps={{ style: { color: '#fff', fontSize: '0.8rem' } }}
                />
              </ListItem>
            );
          })}
        </List>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            marginTop: 8,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          }}
        >
          <DialogActions>
            <Button onClick={onCancel} style={{ color: '#fff' }}>
              Cancel
            </Button>
            <Button onClick={handleReset} style={{ color: '#fff' }}>
              Reset
            </Button>
            <Button onClick={handleApply} color="primary" variant="contained">
              Apply
            </Button>
          </DialogActions>
        </div>
      </DialogContent>
    </Dialog>
  );
}
